// src/pages/Home.js
import React from 'react';
import Login from '../Authentication/Login.js'; 
function Home() {
  return (
    <div>
        <Login/>
    </div>
  );
}

export default Home;